var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import history from '@store/history';
import ContentMenu from 'organisms/ContentMenu';
import VerticalFlex from '@shared/atoms/VerticalFlex';
import WatchlistArea from 'organisms/WatchlistArea';
import WatchlistAreaExpanded from 'organisms/WatchlistAreaExpanded';
import LanguageModal from 'organisms/LanguageModal';
import WatchlistAreaCheckout from 'organisms/WatchlistAreaCheckout';
import ArticleStacks from 'organisms/ArticleStacks';
import TryonFinishModal from 'organisms/TryonFinishModal';
import ReserveFinishModal from 'organisms/ReserveFinishModal';
import GenderSelectionInspirationModal from 'organisms/GenderSelectionModal/GenderSelectionInspirationModal';
import queryString from "query-string";
import moment from "moment";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 100%;\n"], ["\n  display: flex;\n  height: 100%;\n"])));
var LeftColumn = styled(VerticalFlex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: ", ";\n  align-items: stretch;\n  background-color: #e5e5e7; // Fixed color, for every theme\n  transition: width 0.15s, transform 0.15s, flex 0.15s linear;\n  width: ", ";\n  transform: ", ";\n"], ["\n  flex: ", ";\n  align-items: stretch;\n  background-color: #e5e5e7; // Fixed color, for every theme\n  transition: width 0.15s, transform 0.15s, flex 0.15s linear;\n  width: ", ";\n  transform: ", ";\n"])), function (props) { return (!props.fullWatchlist ? 3 : 0); }, function (props) { return (props.fullWatchlist ? "0" : 'auto'); }, function (props) {
    return props.fullWatchlist ? 'transform(-100%, 0)' : 'initial';
});
var RightColumn = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n  max-width: ", ";\n  transition: width 0.15s linear;\n"], ["\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n  max-width: ", ";\n  transition: width 0.15s linear;\n"])), function (props) { return (!props.fullWatchlist ? '26.875rem' : 'auto'); });
var ContentRow = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 8;\n  position: relative;\n  display: flex;\n  overflow: hidden;\n"], ["\n  flex: 8;\n  position: relative;\n  display: flex;\n  overflow: hidden;\n"])));
var ListLayout = /** @class */ (function (_super) {
    __extends(ListLayout, _super);
    function ListLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            expandedWatchlist: false,
            expandedCheckout: false,
            isOneClick: false,
            showFinishModal: false,
            showGenderModal: false,
            target: null,
            showLanguageModal: false,
            nextVal: 'tryOn',
        };
        _this.toggleFullWatchlist = function (nextVal, isOneClick, shouldClose) {
            if (isOneClick === void 0) { isOneClick = false; }
            if (shouldClose === void 0) { shouldClose = false; }
            var nextState = !_this.state.expandedWatchlist;
            if (shouldClose || isOneClick) {
                nextState = false;
            }
            _this.setState({
                showFinishModal: isOneClick || false,
                expandedWatchlist: nextState,
                isOneClick: isOneClick || false,
                nextVal: nextVal,
            });
        };
        _this.toggleCheckout = function (isOneClick) {
            if (isOneClick === void 0) { isOneClick = false; }
            var shouldBeOneClick = isOneClick || false;
            if (!isOneClick) {
                var watchlist = _this.props.watchlist;
                shouldBeOneClick = watchlist.length === 1;
            }
            _this.setState({
                expandedCheckout: !_this.state.expandedCheckout,
                isOneClick: shouldBeOneClick,
            });
        };
        _this.transformHiddenItem = function (usage) {
            if (usage === void 0) { usage = 'remember'; }
            var _a = _this.props, hiddenItem = _a.hiddenItem, createWatchlistItem = _a.createWatchlistItem, watchlist = _a.watchlist;
            if (watchlist.length === 0 && Boolean(hiddenItem) && hiddenItem) {
                createWatchlistItem(__assign(__assign({}, hiddenItem), { loadFurniture: true, usage: usage || 'remember' }));
            }
        };
        _this.toggleLanguageModal = function () {
            _this.setState({
                showLanguageModal: !_this.state.showLanguageModal,
            });
        };
        _this.toggleGenderModal = function () {
            _this.setState({ showGenderModal: !_this.state.showGenderModal });
        };
        _this.openModalWithTarget = function (target) {
            _this.setState({
                showGenderModal: true,
                target: target,
            });
        };
        _this.clickServiceCall = function () {
            var updateSession = _this.props.updateSession;
            var now = moment().format();
            updateSession({ serviceCallAt: now });
            _this.toggleFullWatchlist('remember', false, true);
        };
        _this.closeAndProceed = function (primaryCategoryId) {
            var _a = queryString.parse(window.location.search), category = _a.category, primaryCategory = _a.primaryCategory, sort = _a.sort, rest = __rest(_a, ["category", "primaryCategory", "sort"]);
            var queryStringExceptCategory = queryString.stringify(rest);
            /* NEED-326 */
            if (!primaryCategoryId)
                return console.warn('no primary category to set');
            var currentPageUrl = _this.props.currentPageUrl;
            var _b = _this.state, target = _b.target, showGenderModal = _b.showGenderModal;
            /* set state */
            _this.props.setGender(primaryCategoryId.id);
            showGenderModal && _this.setState({ showGenderModal: false });
            /* check if routing is necessary */
            var destination;
            if (!!target) {
                if (target === "/search/" + primaryCategoryId.id) {
                    destination = "/search";
                }
                else if (target === '/inspiration') {
                    destination = "/inspiration/" + primaryCategoryId.inspirationId;
                }
            }
            else if (currentPageUrl === '/results' ||
                currentPageUrl === '/search' ||
                currentPageUrl === '/scan' ||
                currentPageUrl === '/articles') {
                destination = "/search/" + primaryCategoryId.id + "/?" + queryStringExceptCategory;
            }
            else if (currentPageUrl === '/inspiration' && (primaryCategoryId === null || primaryCategoryId === void 0 ? void 0 : primaryCategoryId.inspirationId)) {
                destination = "/inspiration/" + (primaryCategoryId === null || primaryCategoryId === void 0 ? void 0 : primaryCategoryId.inspirationId);
            }
            else {
                destination = "/inspiration/empty";
            }
            /* if new destination set, route */
            destination && history.push(destination);
        };
        return _this;
    }
    ListLayout.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.articleStacks.length === 0 &&
            this.props.articleStacks.length > 0) {
            if (nextProps.currentPageUrl !== '/articles') {
                this.props.resetHidden();
            }
        }
    };
    ListLayout.prototype.renderFinishModal = function () {
        var _this = this;
        var _a = this.state, nextVal = _a.nextVal, showFinishModal = _a.showFinishModal;
        switch (nextVal) {
            case 'reserve':
                return (_jsx(ReserveFinishModal, { open: showFinishModal, toggleAction: function () {
                        return _this.toggleFullWatchlist('remember', false, true);
                    }, finish: this.clickServiceCall }, void 0));
            case 'tryOn':
            default:
                return (_jsx(TryonFinishModal, { open: showFinishModal, toggleAction: function () {
                        return _this.toggleFullWatchlist('remember', false, true);
                    }, finish: this.clickServiceCall }, void 0));
        }
    };
    ListLayout.prototype.render = function () {
        var _a = this.props, articleStacks = _a.articleStacks, checkingOut = _a.checkingOut, checkout = _a.checkout, checkoutNumber = _a.checkoutNumber, children = _a.children, createArticleStack = _a.createArticleStack, createCustomer = _a.createCustomer, createWatchlistItem = _a.createWatchlistItem, currentGender = _a.currentGender, currentLanguage = _a.currentLanguage, currentPageUrl = _a.currentPageUrl, currentStoreId = _a.currentStoreId, deleteArticleStack = _a.deleteArticleStack, deleteSession = _a.deleteSession, deleteWatchlistItem = _a.deleteWatchlistItem, furniture = _a.furniture, furnituresReady = _a.furnituresReady, getDuration = _a.getDuration, getFurnitures = _a.getFurnitures, getStackArticle = _a.getStackArticle, getStackArticles = _a.getStackArticles, hiddenItem = _a.hiddenItem, orderNumber = _a.orderNumber, orderError = _a.orderError, primaryCategories = _a.primaryCategories, resetHidden = _a.resetHidden, saveHidden = _a.saveHidden, selectLanguage = _a.selectLanguage, sendOrder = _a.sendOrder, session = _a.session, shareSession = _a.shareSession, stores = _a.stores, submitCustomerBasicForm = _a.submitCustomerBasicForm, submitCustomerForm = _a.submitCustomerForm, theme = _a.theme, updateSession = _a.updateSession, updateWatchlistItem = _a.updateWatchlistItem, waitingDuration = _a.waitingDuration, watchlist = _a.watchlist;
        var _b = this.state, expandedCheckout = _b.expandedCheckout, expandedWatchlist = _b.expandedWatchlist, isOneClick = _b.isOneClick, showFinishModal = _b.showFinishModal, nextVal = _b.nextVal, showGenderModal = _b.showGenderModal;
        var switches = theme && theme.switches;
        var image = theme &&
            // eslint-disable-next-line no-nested-ternary
            (nextVal
                ? nextVal === 'reserve'
                    ? theme.reservationImage
                    : theme.tryOnImage
                : null);
        return (_jsxs(Wrapper, { children: [_jsxs(LeftColumn, __assign({ fullWatchlist: !showFinishModal && (expandedWatchlist || expandedCheckout) }, { children: [_jsx(ContentMenu, { currentPageUrl: currentPageUrl, getDuration: getDuration, logo: theme.logoUrl, session: session, primaryCategories: localStorage.getItem("customerId") == "59192" ? primaryCategories.slice(0, 2) : primaryCategories, updateSession: updateSession, waitingDuration: waitingDuration, currentGender: currentGender, toggleSelection: this.openModalWithTarget, switchGender: this.closeAndProceed, theme: theme }, void 0), _jsx(ContentRow, { children: Boolean(articleStacks) && articleStacks.length !== 0 ? (_jsx(ArticleStacks, { articleStacks: articleStacks, createArticleStack: createArticleStack, createWatchlistItem: createWatchlistItem, deleteArticleStack: deleteArticleStack, deleteWatchlistItem: deleteWatchlistItem, getStackArticle: getStackArticle, getStackArticles: getStackArticles, resetHidden: resetHidden, saveHidden: saveHidden, watchlist: watchlist }, void 0)) : (children) }, void 0)] }), void 0), _jsxs(RightColumn, __assign({ fullWatchlist: !showFinishModal && (expandedWatchlist || expandedCheckout) }, { children: [_jsx(WatchlistArea, { switches: theme.switches, createArticleStack: createArticleStack, currentLanguage: currentLanguage, deleteSession: deleteSession, deleteWatchlistItem: deleteWatchlistItem, hiddenItem: hiddenItem, session: session, updateSession: updateSession, shareSession: shareSession, show: !expandedWatchlist, toggleCheckout: this.toggleCheckout, toggleFullWatchlist: this.toggleFullWatchlist, toggleLanguageModal: this.toggleLanguageModal, transformHiddenItem: this.transformHiddenItem, watchlist: watchlist, theme: theme }, void 0), _jsx(WatchlistAreaExpanded, { initialStateValue: 'remember', isOneClick: isOneClick, logo: theme.logoUrl, assistantPhoto: image, nextStateValue: nextVal, show: expandedWatchlist && !isOneClick, toggleFullWatchlist: this.toggleFullWatchlist, updateSession: updateSession, updateWatchlistItem: updateWatchlistItem, watchlist: watchlist }, void 0), _jsx(WatchlistAreaCheckout, { checkingOut: checkingOut, checkout: checkout, checkoutNumber: checkoutNumber, createCustomer: createCustomer, createWatchlistItem: createWatchlistItem, currentStoreId: currentStoreId, deleteSession: deleteSession, deleteWatchlistItem: deleteWatchlistItem, furniture: furniture, furnituresReady: furnituresReady, getFurnitures: getFurnitures, initialStateValue: 'remember', isOneClick: isOneClick, logo: theme.logoUrl, nextStateValue: 'checkout', orderNumber: orderNumber, orderError: orderError, sendOrder: sendOrder, session: session, show: expandedCheckout, stores: stores, submitCustomerBasicForm: submitCustomerBasicForm, submitCustomerForm: submitCustomerForm, switches: switches, toggleCheckout: this.toggleCheckout, updateSession: updateSession, updateWatchlistItem: updateWatchlistItem, watchlist: watchlist }, void 0)] }), void 0), _jsx(LanguageModal, { currentLanguage: currentLanguage, open: false, selectLanguage: selectLanguage, toggleAction: this.toggleLanguageModal }, void 0), _jsx(GenderSelectionInspirationModal, { open: showGenderModal, onClose: this.closeAndProceed, onPrimaryCategorySelect: this.toggleGenderModal, primaryCategories: primaryCategories }, void 0), showFinishModal && this.renderFinishModal()] }, void 0));
    };
    return ListLayout;
}(Component));
export default withTheme(ListLayout);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
